import { UTILS__VALIDATOR__is_array } from '../../utils/validator'

export const AUTH__SET = value => {
    return {
        type: 'AUTH__SET',
        payload: value,
    }
}

export const AUTH__LOGIN_REFRESH = (obj, optionalId = null) => {
    const payload = {
        user: {
            // role: obj.user.role,
            authorities: obj.user.authorities,
            id: obj.user.id,
            optionalId: null,
            email: obj.user.login,
        },
        token: {
            scope: Array.isArray(obj.scope) ? obj.scope : obj.scope.split(' '),
            type: obj.token_type,
            access: obj.access_token,
            access_expires_in: obj.expires_in,
            refresh: obj.refresh_token,
        },
    }

    if (obj.user.authorities) {
        if (UTILS__VALIDATOR__is_array(obj.user.authorities)) {
            if (obj.user.authorities.filter(el => el.authority === 'ROLE_ADMIN')) {
                if (optionalId) {
                    payload.user.optionalId = parseInt(optionalId)
                }
            }
        }
    }

    return {
        type: 'AUTH__LOGIN_REFRESH',
        payload,
    }
}

export const AUTH__LOGOUT = () => {
    return {
        type: 'AUTH__LOGOUT',
    }
}
